import styled from 'styled-components'

export default styled.div`
	.job-list-placeholder {
		.job-item-placeholder {
			border: 1px solid #ececec;
			padding: 20px;
			margin-bottom: 15px;
			border-radius: 6px;
		}
	}
`
